import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { StudentForDiagnosticDetail, UnassignDiagnosticLessonsVM, StudentForDiagnostic, AssignmentForStudentDiagnostic, LessonProgressReleaseAllByStudent } from 'src/app/Elearning-Models';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { ColorCodes } from 'src/app/ColorCodes';
import { UnassignDiaglogComponent } from 'src/app/layouts/CSA/shared/unassign-diaglog/unassign-diaglog.component';
import { MatDialog } from '@angular/material/dialog';
import { StudentData } from 'src/app/Services/API-Service/MockValuesService/gradebookDataMockValues.service';
import { ReleaseAllDialogComponent } from 'src/app/layouts/CSA/shared/release-all-dialog/release-all-dialog.component';

@Component({
  selector: 'app-student-panel',
  templateUrl: './student-panel.component.html',
  styleUrls: ['./student-panel.component.scss']
})
export class StudentPanelComponent implements OnInit {
  @Input() studentData: StudentForDiagnosticDetail;
  @Input() isExpanded: boolean;
  @Input() classID: number;
  @Input() diagExamID: number;
  @Output() unassigned: EventEmitter<UnassignDiagnosticLessonsVM> = new EventEmitter<UnassignDiagnosticLessonsVM>();
  @Output() released: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() removeFromSkipList: EventEmitter<StudentForDiagnostic[]> = new EventEmitter<StudentForDiagnostic[]>();

  completionPercentage: number;
  colorIndicators = new ColorCodes().colorIndicators;
  assignments :AssignmentForStudentDiagnostic[];

  filter: number = -1;

  constructor(private APIService: IAPIService,
    private dialog: MatDialog) { 
    
  }

  ngOnInit(): void {
    this.completionPercentage = Number(((this.studentData.LessonsCompleted / this.studentData.LessonsAssigned)*100).toFixed());
    this.assignments = this.studentData.Assignments;
  }

  filterILP(index: number){
    switch(index){
      case 0: // assigned
      {
        this.filter = 0;
        this.studentData.Assignments = this.assignments.filter(a => a.AttemptID == -1);
        break;
      }
      case 1: // grade no released
      {
        this.filter = 1;
        this.studentData.Assignments = this.assignments.filter(a => a.Grade && !a.GradeReleased);
        break;
      }
      case 2: // graded 
      {
        this.filter = 2;
        this.studentData.Assignments = this.assignments.filter(a => a.Grade && a.GradeReleased);
        break;
      }
      case 3: // sent back
      {
        this.filter = 3;
        this.studentData.Assignments = this.assignments.filter(a => a.SentBack);
        break;
      }
      case 4: // ungraded
      {
        this.filter = 4;
        this.studentData.Assignments = this.assignments.filter(a => !a.Grade && !a.GradeReleased && a.SubmittedAsComplete);
        break;
      }
      default:
      {
        this.filter = -1;
        this.studentData.Assignments = this.assignments;
        break;
      }
    }
  
  }

  unassignDiagnosticLesson($event){
    // This is passing the lesson from assignment card up to the main page
    let model : UnassignDiagnosticLessonsVM = $event;
    
    this.unassigned.emit(model);
  }

  openReleaseAllLessonsDialog(){
    const dialogRef = this.dialog.open(ReleaseAllDialogComponent, {
			data: {
				data: this.assignments, // all of the assignments
				title: this.studentData.StudentName,
				type: 'Assignments'
			},
			autoFocus: false,
			panelClass: 'app-release-all-dialog'
		});

		const sub = dialogRef.componentInstance.releaseAllSelected.subscribe(selectedValues => 
			{
				var model = new LessonProgressReleaseAllByStudent();
					model.Threshold= selectedValues.threshold,
					model.Reassign= selectedValues.reassign,
					model.ClassID= this.classID,
					model.ReassignShowIcon= selectedValues.reassignOption,
					model.ReassignShowAnswer= selectedValues.reassignSubOption,
          model.StudentID= this.studentData.StudentID,
          model.DiagnosticExamID = this.diagExamID
				

				this.APIService.ReleaseAllGradesByStudentID(model).subscribe(response => {
          this.emitReleaseAll(response);
				});
			});

		dialogRef.afterClosed().subscribe(result => {
			sub.unsubscribe();
		})
  }

  emitReleaseAll(response: boolean){
      this.released.emit(response);
  }

  openUnassignAllLessonsDialog(){
    const dialogRef = this.dialog.open(UnassignDiaglogComponent, {
			data: {
			  studentName: this.studentData.StudentName,
			},
			autoFocus: false,
		  });
	  
		  const sub = dialogRef.componentInstance.unassignYes.subscribe(
			(result: boolean) => {
			  if(result){
				this.unassignAllDiagnosticLessons();
			  }
			}
		  );
	  
		  dialogRef.afterClosed().subscribe((result) => {
			sub.unsubscribe();
		  });
  }

  unassignAllDiagnosticLessons(){
    var model = new UnassignDiagnosticLessonsVM();
    model.StudentID = this.studentData.StudentID;
    model.DiagnosticExamID = this.diagExamID;

    this.APIService.UnassignDiagnosticLessons(model).subscribe( response => {
      this.emitUnassigned(response, model);
    });
  }

  emitUnassigned(response: boolean, model: UnassignDiagnosticLessonsVM){
    if(response){
      this.unassigned.emit(model);
    }
    else{
      this.unassigned.emit(null);
    }
  }

  removeStudentFromSkipList(){
    var student = new StudentForDiagnostic();
    student.StudentID = this.studentData.StudentID
    student.StudentName = this.studentData.StudentName;

    var students = [];
    students.push(student);

    this.removeFromSkipList.emit(students);
  }
}
